<template>
  <el-table
    :data="tableData"
    ref="table"
    border
    stripe
    header-row-class-name="his-row-header"
    header-cell-class-name="his-cell_header"
    row-class-name="his-row"
    cell-class-name="his-cell"
    :cell-style="cellStyleVal"
    class="state-table"
  >
    <el-table-column
      :show-overflow-tooltip="true"
      :label="'传感器' | translateTo"
      prop="mod"
      align="center"
      width="217px"
    >
      <template slot-scope="scope">
        <span>{{ scope.row.mod | translateTo }}</span>
      </template>
    </el-table-column>
    <el-table-column
      :show-overflow-tooltip="true"
      :label="'当前值' | translateTo"
      prop="cur"
      align="center"
      width="188px"
    >
      <template slot-scope="scope">
        <span>{{ scope.row.cur | translateTo }}</span>
      </template>
    </el-table-column>
    <el-table-column
      :show-overflow-tooltip="true"
      :label="'变化趋势' | translateTo"
      prop="change"
      align="center"
      width="126px"
    >
      <template #header="{ column }">
        <el-tooltip effect="dark" :content="column.label" placement="top">
          <span>{{ column.label }}</span>
        </el-tooltip>
      </template>
      <template slot-scope="scope">
        <span
          v-if="isStable(scope.row.change) || scope.row.change === '-'"
          :class="0 | stateClass(true)"
          class="change-class"
        >
          {{ translateTo2(scope.row.change) }}
        </span>
        <em class="table-state table-change" :class="scope.row.change | changeIcon" v-else></em>
      </template>
    </el-table-column>
    <el-table-column
      :show-overflow-tooltip="true"
      :label="'设备状态' | translateTo"
      prop="state"
      align="center"
      width="129px"
    >
      <template #header="{ column }">
        <el-tooltip effect="dark" :content="column.label" placement="top">
          <span>{{ column.label }}</span>
        </el-tooltip>
      </template>
      <template slot-scope="scope">
        <span class="table-state" :class="scope.row.state | stateClass(true)">
          {{ scope.row.state | stateText | translateTo }}
        </span>
      </template>
    </el-table-column>
    <el-table-column
      :show-overflow-tooltip="true"
      :label="'运行状态' | translateTo"
      prop="runstate"
      align="center"
      width="141px"
    >
      <template #header="{ column }">
        <el-tooltip effect="dark" :content="column.label" placement="top">
          <span>{{ column.label }}</span>
        </el-tooltip>
      </template>
      <template slot-scope="scope">
        <span class="table-state" :class="scope.row.runstate | runstateClass(true)">
          {{ scope.row.runstate | runstateText | translateTo }}
        </span>
      </template>
    </el-table-column>
    <el-table-column
      :show-overflow-tooltip="true"
      :label="`HT-MARS®${$t('检测结果')}`"
      prop="alarmContent"
      align="center"
    >
      <template #header="{ column }">
        <el-tooltip effect="dark" :content="column.label" placement="top">
          <span>{{ column.label }}</span>
        </el-tooltip>
      </template>

      <template slot-scope="scope">
        <span>{{ scope.row.alarmContent }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { isEmpty } from '@/utils/is';
import { addListener, removeListener } from '@/utils/dom/resize-detector';

export default {
  name: 'StateTable',
  props: {
    tableData: Array
  },
  data() {
    return {
      cellStyleVal: {}
    };
  },
  filters: {
    changeIcon(t) {
      const list = [
        '上升',
        'Подниматься',
        'Augmentation',
        'Aumentar',
        'Rise',
        'Rise/Increase',
        'الارتفاع'
      ];
      return list.includes(t) ? 'el-icon-top top-color' : 'el-icon-bottom bottom-color';
    }
  },
  methods: {
    cellStyle() {
      this.$nextTick(() => {
        const el = this.$refs['table'].$el;

        if (isEmpty(el)) return;

        // 表格td自定义高度
        const h = el.offsetHeight - 48; // 48为表格头部高度

        let seg = 0;
        const l = this.tableData.length;

        /**@type {HTMLElement} */
        const wrap = el.querySelector('.el-table__body-wrapper');
        /**@type {HTMLElement} */
        const body = el.querySelector('.el-table__body');

        if (wrap.clientWidth < body.clientWidth) {
          seg = 8 / l;
        }

        this.cellStyleVal = {
          height: `${h / l - seg}px`,
          padding: '0'
        };
      });
    },
    isStable(v) {
      const list = ['平稳', 'Stable', 'Steady', 'مستقر', 'Estable', 'Стабильный'];

      return list.includes(v);
    },
    translateTo2(text) {
      if (isEmpty(text) || text === '-') return text;

      return this.$t(text);
    }
  },
  mounted() {
    this.cellStyle();
    this.$nextTick(() => {
      const el = this.$refs['table'].$el;

      addListener(el, this.cellStyle);
    });
  },
  beforeDestroy() {
    const el = this.$refs['table'].$el;

    removeListener(el, this.cellStyle);
  }
};
</script>

<style lang="scss">
.state-table.el-table {
  height: calc(100% - 6px);
  border: 1px solid $normal-color;
  box-shadow: 0 0 5px $normal-color;
  font-size: 12px;
  background-color: $tsp;
  &::before {
    background-color: $tsp;
  }
  .his-row-header {
    color: #fff;
    background-color: rgba(72, 156, 214, 0.1);

    .his-cell_header {
      border-color: $normal-color;
      background-color: $tsp;

      .cell {
        white-space: pre;
        word-break: break-word;
      }
    }
  }
  &.el-table--striped {
    .el-table__body {
      .his-row.el-table__row--striped {
        .his-cell {
          background-color: rgba(72, 156, 214, 0.1);
        }
      }
    }
  }

  .el-table__body-wrapper {
    overflow-x: scroll !important;

    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }
    /*定义滑块 内阴影+圆角*/
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background-color: rgba(0, 238, 255, 0.5);
    }
  }

  .his-row {
    color: #fff;
    background-color: $tsp;
    &:hover > td {
      background-color: rgba(13, 23, 33, 0.4);
    }
    .his-cell {
      border-color: $normal-color;
    }
  }
}
.el-table__empty-block {
  color: $regualar-color;
  background-color: $tsp;
}
.change-class {
  @include state-textstyle;
}
.table-state {
  @include state-textstyle;
  &.table-change {
    font-size: 18px;
    &.top-color {
      color: $danger-color;
    }
    &.bottom-color {
      color: $success-color;
    }
  }
}
</style>
